// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type FormsAnswerReview_TreeFragment = { __typename?: 'FormAnswerTree', nodes: Array<{ __typename?: 'FormAnswerNode', kind: Types.FormAnswerNodeKind, isNull: boolean, textValue?: string | null, numberValue?: GraphQLDecimal | null, dateValue?: string | null, singleSelectValue?: string | null, multiSelectValue?: Array<string> | null, itemIDs?: Array<string> | null, target: { __typename?: 'FormAnswerTarget', schemaNodeID: string, arrayItemID?: string | null } }>, assessments: Array<{ __typename?: 'FormNodeAssessment', status: Types.FormNodeAssessmentStatus, reasoning: string, aiRevisionID: string, target: { __typename?: 'FormAnswerTarget', schemaNodeID: string, arrayItemID?: string | null } }> };

export const Operations = {
  Fragment: {
    FormsAnswerReview_Tree: 'FormsAnswerReview_Tree' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const FormsAnswerReview_TreeFragmentDoc = gql`
    fragment FormsAnswerReview_Tree on FormAnswerTree {
  nodes {
    target {
      schemaNodeID
      arrayItemID
    }
    kind
    isNull
    textValue
    numberValue
    dateValue
    singleSelectValue
    multiSelectValue
    itemIDs
  }
  assessments {
    target {
      schemaNodeID
      arrayItemID
    }
    status
    reasoning
    aiRevisionID
  }
}
    `;